import getApiBaseUrl from '@/utils/getBaseUrl';
import { useMutation } from '@tanstack/react-query';

export default function useUploadPhoto() {
  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: FormData) => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/common/files/upload-image`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: payload,
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
  });
}
